<template>
  <b-row class="pt-5 align-items-center">
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">درگاه ریالی فعال</h3>
          </div>
        </div>
        <div v-if="loadedGatewayCount!=null" class="card-body">{{ loadedGatewayCount }} عدد</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">درگاه دلاری فعال</h3>
          </div>
        </div>
        <div class="card-body" v-if="loadedActiveDollarGatewayCount!=null">{{ loadedActiveDollarGatewayCount }} عدد</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">مشتریان</h3>
          </div>
        </div>
        <div class="card-body" v-if="loadedCustomerCount!=null">{{ loadedCustomerCount }} عدد</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">کل موجودی شپا</h3>
          </div>
        </div>
        <!-- sdfsdf:{{loadedBalanceSaman1 + loadedBalanceSaman2 + loadedBalanceSaderat}} -->
        <div class="card-body" v-if="(loadedBalanceSaman1 || loadedBalanceSaman2 || loadedBalanceSaderat)!=null">
          {{
            Number(
              loadedBalanceSaman1 + loadedBalanceSaman2 + loadedBalanceSaderat
            ).toLocaleString()
          }}
          ريال
        </div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">در حال تسویه</h3>
          </div>
        </div>
        <div class="card-body" v-if="loadedSattlingBalance!=null">
          <b-row>
            <b-col cols="6" md="12" sm="12">
              {{ Number(loadedSattlingBalance).toLocaleString() }} ريال
            </b-col>
          </b-row>
        </div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">
              بستانکاران
              <!-- <small>sub title</small> -->
            </h3>
          </div>
        </div>
        <div v-if="loadedBalanceCreditors!=null" class="card-body">
          {{ Number(loadedBalanceCreditors).toLocaleString() }} ریال
        </div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">تراکنش ریالی ماه جاری</h3>
          </div>
        </div>
        <div v-if="loadedMonthTransactionCount!=null" class="card-body">{{ loadedMonthTransactionCount }} عدد</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">تراکنش دلاری ماه جاری</h3>
          </div>
        </div>
        <div v-if="loadedMonthDollerTransactionCount!=null" class="card-body">{{ loadedMonthDollerTransactionCount }} عدد</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>

    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">درآمد های ریالی ماه جاری</h3>
          </div>
        </div>
        <div v-if="loadedMonthIncome!=null" class="card-body">{{ loadedMonthIncome.toLocaleString() }} ریال</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">درآمد های دلاری ماه جاری</h3>
          </div>
        </div>
        <div v-if="loadedUsMonthIncome!=null" class="card-body">{{ loadedUsMonthIncome.toLocaleString() }} دلار</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">میانگین پاسخگویی به تیکت</h3>
          </div>
        </div>
        <div v-if="loadedUsMonthIncome!=null" class="card-body">۱۵ دقیقه</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
    <b-col cols="12" md="3" sm="4">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">درصد پرداخت های ناموفق</h3>
          </div>
        </div>
        <div v-if="loadedUsMonthIncome!=null" class="card-body">۰.۵٪</div>
        <div v-else class="card-body"><b-spinner variant="success" type="grow" label="Spinning"></b-spinner></div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  GET_SAMAN1_BALANCE,
  GET_SAMAN2_BALANCE,
  GET_SADERAT_BALANCE,
} from "@/core/services/store/getBalance.module";
import { GET_CREDITORS } from "@/core/services/store/getCreditors.module";
import { GET_CUSTOMER_COUNT } from "@/core/services/store/getCountCustomer.module";

export default {
  name: "Balanc",
  data() {
    return {};
  },
  computed: {
    loadedBalanceSaman1() {
      return this.$store.getters.loadedBalanceSaman1;
    },
    loadedBalanceSaman2() {
      return this.$store.getters.loadedBalanceSaman2;
    },
    loadedBalanceSaderat() {
      return this.$store.getters.loadedBalanceSaderat;
    },
    loadedCustomerCount() {
      return this.$store.getters.loadedCustomerCount;
    },
    loadedGatewayCount() {
      return this.$store.getters.loadedGatewayCount;
    },
    loadedSattlingBalance() {
      return this.$store.getters.loadedSattlingBalance;
    },
    loadedBalanceCreditors() {
      return this.$store.getters.loadedBalanceCreditors;
    },
    loadedMonthTransactionCount() {
      return this.$store.getters.loadedMonthTransactionCount;
    },
    loadedMonthDollerTransactionCount() {
      return this.$store.getters.loadedMonthDollerTransactionCount;
    },
    loadedActiveDollarGatewayCount() {
      return this.$store.getters.loadedActiveDollarGatewayCount;
    },

    loadedMonthIncome() {
      return this.$store.getters.loadedMonthIncome;
    },
    loadedUsMonthIncome() {
      return this.$store.getters.loadedUsMonthIncome;
    },
  },
  mounted() {
    this.getBalanceSaman1();
    this.getBalanceSaman2();
    this.getBalanceSaderat();
    this.getCountCustomer();
    this.getCreditors();
  },
  methods: {
    getBalanceSaman1() {
      this.$store.dispatch(GET_SAMAN1_BALANCE, "sharing/get_balance/Saman");
    },
    getBalanceSaman2() {
      this.$store.dispatch(GET_SAMAN2_BALANCE, "sharing/get_balance/Saman2");
    },
    getBalanceSaderat() {
      this.$store.dispatch(GET_SADERAT_BALANCE, "sharing/get_balance/Saderat");
    },
    getCountCustomer() {
      this.$store.dispatch(GET_CUSTOMER_COUNT, "admindashboard");
    },
    getCreditors() {
      this.$store.dispatch(GET_CREDITORS, "creditors");
    },
  },
};
</script>

<style>
</style>